/**
 * 以下接口为启用的后端接口
 */
export default ['api/test', 'oss/info', 'Chase_BaseQueryDBServerTime']



// WEBPACK FOOTER //
// ./src/mock/index.js